export default "__VITE_ASSET__DNl$5x50__"